import { Divider, Stack, TextField, Typography } from "@mui/material";
import { useContext, useEffect } from "react";
import { WebFormContext } from "../../../../context/WebFormContext";
import { trackEventMatomo } from "../../../../helpers/matomo";
import { SubItemFormFilling } from "../../../../types/new-form-filling/types";
import IconsRender from "../../../ChecklistV2/IconsRender";
import CheckIcon from "../../CheckIcon";
import { getNumberMask, normalizeToFloat, formatLocaleValue } from "../../../../helpers/getNumberMask";
import AdditionalInfo from "../../Structure/AdditionalInfo";

type Props = {
  value: number | string;
  setValue: Function;
  required?: boolean;
  subitem: SubItemFormFilling;
};

export default function NumberOrValue({ value, setValue, required, subitem }: Props) {
  const { ForceUpdate } = useContext(WebFormContext);

  const textFieldTitle: string = (() => {
    let title = "";
    if (CheckIcon(subitem, value) === "naoOk") {
      title += "* ";
    }
    title += `${subitem.id + 1} - ${subitem.nome}`;
    return title;
  })();

  // function handleParse(value: string): number | string {
  //   const valorPorCem = parseInt(value) / 100;
  //   const valorInputDecimal = valorPorCem
  //     .toLocaleString("pt-BR", {
  //       minimumFractionDigits: 2,
  //       maximumFractionDigits: 2,
  //     })
  //     .replace(/\s/g, "")
  //     .replace(",", ".");
  //   return parseFloat(valorInputDecimal) ?? "";
  // }

  const checkItem = (tipo: string) => {
    const image = subitem.foto;
    const text = subitem.comentario;
    const arquivo = subitem.permiteArquivo;
    if (image || text || arquivo) {
      const numVal = normalizeToFloat(subitem.ocorrencia);
      if (numVal !== null && numVal !== undefined && !isNaN(numVal)) {
        if (tipo === "numero") {
          const minVal = normalizeToFloat(subitem.minNumberVal);
          const maxVal = normalizeToFloat(subitem.maxNumberVal);
          const isMinValid = minVal !== null && minVal !== undefined && !isNaN(minVal);
          const isMaxValid = maxVal !== null && maxVal !== undefined && !isNaN(maxVal);

          if (isMinValid || isMaxValid) {
            const meetsMin = !isMinValid || numVal >= minVal;
            const meetsMax = !isMaxValid || numVal <= maxVal;
            if (meetsMin && meetsMax) {
              return <AdditionalInfo subItem={subitem} />;
            }
          } else {
            return <AdditionalInfo subItem={subitem} />;
          }
        } else if (tipo === "valorMedida") {
          const minVal = normalizeToFloat(subitem.min);
          const maxVal = normalizeToFloat(subitem.max);
          const isMinValid = minVal !== null && minVal !== undefined && !isNaN(minVal);
          const isMaxValid = maxVal !== null && maxVal !== undefined && !isNaN(maxVal);

          if (isMinValid || isMaxValid) {
            const meetsMin = !isMinValid || numVal >= minVal;
            const meetsMax = !isMaxValid || numVal <= maxVal;
            if (meetsMin && meetsMax) {
              return <AdditionalInfo subItem={subitem} />;
            }
          } else {
            return <AdditionalInfo subItem={subitem} />;
          }
        } else {
          return <AdditionalInfo subItem={subitem} />;
        }
      }
    }
  };

  useEffect(() => {
    if (subitem.ocorrencia) {
      setValue(formatLocaleValue(subitem.ocorrencia));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (subitem.ocorrencia) return;
    if (subitem.padrao) {
      setValue(formatLocaleValue(subitem.padrao));
      subitem.ocorrencia = formatLocaleValue(subitem.padrao);
    }
    if (CheckIcon(subitem, value) === "ok") {
      subitem.checked = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (CheckIcon(subitem, value) === "ok") {
      subitem.checked = true;
    } else if (!value) {
      delete subitem.checked;
    }
    ForceUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const minOrMax = () => {
    if (subitem.minNumberVal || subitem.maxNumberVal) {
      return true;
    }
    if (subitem.max || subitem.min) {
      return true;
    }
    return false;
  };

  return (
    <>
      <Typography
        variant="h6"
        style={{
          wordBreak: "break-all",
          marginBottom: "5px",
          width: "100%",
          textAlign: "left",
        }}>
        {textFieldTitle}
      </Typography>
      <Stack direction="row" justifyContent="center" alignItems="center" width="100%" spacing={1}>
        <TextField
          InputProps={{
            startAdornment: (
              <>
                {subitem.tipo === "valorMedida" ? (
                  <>
                    <IconsRender value={subitem?.subtipo as string} /> |
                  </>
                ) : (
                  ""
                )}
              </>
            ),
          }}
          required={required}
          className={`${subitem.itemid}|${subitem.id}`}
          fullWidth
          type="text"
          value={value ?? ""}
          onClick={() => trackEventMatomo("formSubitem", "click", "input", "edita valor")}
          onChange={(event) => {
            if (!event.target.value) {
              setValue("");
              subitem.ocorrencia = "";
              return;
            };
            const valor = getNumberMask(event.target.value);
            setValue(valor);
            subitem.ocorrencia = valor;
          }}
          sx={{
            height: "100%",
            backfaceVisibility: "hidden",
          }}
          onBlur={(event) => {
            if (!event.target.value) {
              setValue("");
              subitem.ocorrencia = "";
              return;
            };
            const valor = getNumberMask(event.target.value);
            if (valor === "" || !isNaN(parseFloat(valor))) {
              subitem.ocorrencia = valor;
            }
          }}
        />
        {minOrMax() && (
          <>
            <TextField
              sx={{ width: 100 }}
              disabled
              label="min"
              value={formatLocaleValue(subitem.minNumberVal ?? subitem.min)}
              variant="standard"
              inputProps={{ style: { textAlign: "center" } }}
            />
            <Divider orientation="vertical" variant="middle" flexItem />
            <TextField
              sx={{ width: 100 }}
              disabled
              label="max"
              value={formatLocaleValue(subitem.maxNumberVal ?? subitem.max)}
              variant="standard"
              inputProps={{ style: { textAlign: "center" } }}
            />
          </>
        )}
      </Stack>
      {checkItem(subitem.tipo)}
    </>
  );
}
